import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React, { useEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import { KeyProvisionForEmacApac } from "../KeyProvisions/key-provision-emac-apac";
import "./styles.css";
import { useParams } from "react-router-dom";
import { CapitalPlanEditForm } from "../CapitalPlan/dap-capitalplan-edit-form";
import { RecommendationTestForm } from "../Recommendation/dap-recommendation_test";
import { RecommendationViewTestForm } from "../Recommendation/dap-recommendation_view";
import { CapitalPlanDisplayForm } from "../CapitalPlan/dap-capitalplan-display-form";
import { SwotEditForm } from "../Swot/dap-swot-edit-form";
import { SummaryEditForm } from "../Summary/dap-summary-edit-form";
import { SummaryInternationalEditForm } from "../Summary/dap-summary-international-edit-form";
import { SummaryInternationalDisplayForm } from "../Summary/dap-summary-international-display-form";
import { SiteStackingEditForm } from "../SiteStacking/dap-sitestacking-edit-form";
import { SiteStackingViewForm } from "../SiteStacking/dap-sitestacking-view-form";
import { SwotDisplayForm } from "../Swot/dap-swot-display-form";
import { SwotGlobalEditForm } from "../Global/dap-swot-global-edit-form";
import { SwotGlobalDisplayForm } from "../Global/dap-swot-global-display-form";
import Documents from "../Documents/Documents";
import { KeyProvision } from "../KeyProvisions/key-provision-edit-form";
import Title from "../../../layout/Title";
import { LeasingResidentialEditForm } from "../Leasing/leasing-residential-edit";
import { LeasingCommercialEditFormNew } from "../Leasing/leasing-commercial-edit-new";
import { ValuationForm } from "../Valuation/valuation";
import PostCLosing from "../PostClosingItem/Post-CLosing-Item-edit";
import { DebtForm } from "../Debt/debt-form";
import {
  getInvestmentDetailsById,
  getGlobalInvestmentByAssetId,
  PostData,
} from "../../../redux/slices/summaryFormSlice";
import { SummaryDisplayForm } from "../Summary/dap-summary-display-form";
import { getAssetPlanId } from "../../../redux/slices/assetPlanIdSlice";
import { Financials } from "../Financials/financials";
import NewFormDialog from "../newFormDialog/newFormDialog";
import { getDapComments } from "../../../redux/slices/updateDapCommentSlice";
import { getUserData } from "../../../redux/slices/userSectorDetailSlice";
import SustainabilityForm from "../Sustainability/dap-sustainability-edit-form";
import Compliance from "../Compliance/compliance";
import { PrioritiesEditForm } from "../priorities/dap-priorities-edit-form";
import { PrioritiesDisplayForm } from "../priorities/dap-priorities-display-form";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {/* The Entire Data box */}
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const DapIntroductionForm = (props) => {
  const dispatch = useAppDispatch();
  //Return undefined again
  const showForm = useAppSelector(
    (state) => state.dialog.dialogData.showPopupForm,
  );
  const id = useParams()?.dapId ?? "";
  const [value, setValue] = React.useState(0);
  const [callExecuted, setCallExecuted] = React.useState(false);
  const complianceInvestmentsubtype = [
    "affordable - lihtc",
    "affordable - noah",
    "affordable - retail",
    "affordable - section 8",
    "developable - affordable",
    "ground lease - affordable",
  ];
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  //Contains the data of the Asset that was Viwed or Edited
  const dapData = useAppSelector((state) => state.summary.dapData);


  console.log("DAP Data",dapData);
  
  const postData: PostData = {
    //ID Derived prom url Params
    dapId: id,
  };

  useEffect(() => {
    if (!callExecuted) {
      dispatch(getInvestmentDetailsById(postData));
      dispatch(getAssetPlanId(id));
      setCallExecuted(true);
    }
  }, [postData, id]);

  useEffect(() => {
    if (dapData?.internationalInd === "Y" && dapData?.assetPlanId) {
      dispatch(getGlobalInvestmentByAssetId({ dapId: dapData.assetPlanId }));
    }
  }, [dapData?.internationalInd, dapData?.assetPlanId, dispatch]);
  useEffect(() => {
    dispatch(getDapComments(id));
  }, [id, dispatch]);

  const userEmail = ""; //bryan.morland@nuveen.com
  useEffect(() => {
    dispatch(getUserData(userEmail));
  }, [userEmail, dispatch]);

  return (
    <div className="dashboard-wrap">
      <Title mode={props.mode} />
      <Box sx={{ borderBottom: "none", borderColor: "divider" }}>
        <Tabs
          TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
          className="main-tab"
          value={value}
          onChange={handleChange}
          variant="scrollable"
          aria-label="basic tabs example"
          allowScrollButtonsMobile={true}
        >
          <Tab label="Summary" />
          <Tab label="Recommendations" />
          {dapData?.internationalInd === "Y" && <Tab label="Priorities" />}
          <Tab label="Sustainability" />
          <Tab label="Site/Stacking Plan" />
          <Tab label="Financial" />
          <Tab label="Capital Plan" />
          <Tab label="SWOT" />
          <Tab label="Leasing" />
          <Tab label="Valuation" />
          <Tab label="Debt" />
          <Tab label="Key Provisions" />
          {dapData?.investmentSubtype &&
            complianceInvestmentsubtype.includes(
              dapData.investmentSubtype.toLowerCase(),
            ) && <Tab label="Compliance" />}
          <Tab label="Comments" />
          <Tab label="Documents" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        {props.mode === "edit" && (
          dapData?.internationalInd === "Y" ? <SummaryInternationalEditForm /> : <SummaryEditForm />
        )}
        {props.mode === "view" && (
          dapData?.internationalInd === "Y" ? <SummaryInternationalDisplayForm /> : <SummaryDisplayForm />
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {props.mode === "edit" && <RecommendationTestForm />}
        {props.mode === "view" && <RecommendationViewTestForm />}
      </TabPanel>
      {dapData?.internationalInd === "Y" && (
        <TabPanel value={value} index={2}>
          {props.mode === "edit" && <PrioritiesEditForm />}
          {props.mode === "view" && <PrioritiesDisplayForm />}
        </TabPanel>
      )}
      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 3 : 2}>
        <SustainabilityForm mode={props.mode} />
      </TabPanel>
      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 4 : 3}>
        {props.mode === "edit" && <SiteStackingEditForm />}
        {props.mode === "view" && <SiteStackingViewForm />}
      </TabPanel>

      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 5 : 4}>
        <Financials mode={props.mode} />
      </TabPanel>

      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 6 : 5}>
        {props.mode === "edit" && <CapitalPlanEditForm />}
        {props.mode === "view" && <CapitalPlanDisplayForm />}
      </TabPanel>

      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 7 : 6}>
        {dapData?.internationalInd === "Y" ? (
          <>
            {props.mode === "edit" && <SwotGlobalEditForm />}
            {props.mode === "view" && <SwotGlobalDisplayForm />}
          </>
        ) : (
          <>
            {props.mode === "edit" && <SwotEditForm />}
            {props.mode === "view" && <SwotDisplayForm />}
          </>
        )}
      </TabPanel>

      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 8 : 7}>
        {dapData?.internationalInd === "Y" ? (
          <LeasingCommercialEditFormNew mode={props.mode} />
        ) : (
          <>
            {dapData?.propertyType === "Residential" && (
              <LeasingResidentialEditForm mode={props.mode} />
            )}
            {dapData?.propertyType === "Commertial" && (
              <>
                <LeasingCommercialEditFormNew mode={props.mode} />
              </>
            )}
            {dapData?.propertyType === "Mixed" && (
              <>
                <LeasingResidentialEditForm mode={props.mode} />
                <LeasingCommercialEditFormNew mode={props.mode} />
              </>
            )}
          </>
        )}
      </TabPanel>

      <TabPanel value={value} index={dapData?.internationalInd === "Y" ? 9 : 8}>
        <ValuationForm mode={props.mode} />
      </TabPanel>
      <TabPanel
        value={value}
        index={dapData?.internationalInd === "Y" ? 10 : 9}
      >
        <DebtForm mode={props.mode} />
      </TabPanel>
      <TabPanel
        value={value}
        index={dapData?.internationalInd === "Y" ? 11 : 10}
      >
        {dapData?.internationalInd === "Y" ? (
          <KeyProvisionForEmacApac mode={props.mode} />
        ) : (        
          <KeyProvision mode={props.mode} />
        )}
      </TabPanel>
      {dapData?.investmentSubtype &&
        complianceInvestmentsubtype.includes(
          dapData.investmentSubtype.toLowerCase(),
        ) && (
          <TabPanel
            value={value}
            index={dapData?.internationalInd === "Y" ? 12 : 11}
          >
            <Compliance mode={props.mode} />
          </TabPanel>
        )}
      <TabPanel
        value={value}
        index={
          dapData?.investmentSubtype &&
          complianceInvestmentsubtype.includes(
            dapData.investmentSubtype.toLowerCase(),
          )
            ? dapData?.internationalInd === "Y"
              ? 13
              : 12
            : dapData?.internationalInd === "Y"
              ? 12
              : 11
        }
      >
        <PostCLosing mode={props.mode} />
      </TabPanel>

      <TabPanel
        value={value}
        index={
          dapData?.investmentSubtype &&
          complianceInvestmentsubtype.includes(
            dapData.investmentSubtype.toLowerCase(),
          )
            ? dapData?.internationalInd === "Y"
              ? 14
              : 13
            : dapData?.internationalInd === "Y"
              ? 13
              : 12
        }
      >
        <Documents mode={props.mode} />
      </TabPanel>

      {showForm && <NewFormDialog />}
    </div>
  );
};
